import { Spin } from "antd";
import { Card, Col } from "reactstrap";
import AdminActivitiesCardHeader from "./AdminActivitiesCardHeader";
import AdminActivitiesCardBody from "./AdminActivitiesCardBody";

const AdminActivities = ({ adminActivities, loading }) => {
  return (
    <Col xl="6" md="6" className="box-col-33">
      <Card className="our-todolist relative">
        {loading && <div className={`charts-initial-loading`}><Spin/></div>}
        <AdminActivitiesCardHeader />
        <AdminActivitiesCardBody adminActivities={adminActivities} />
      </Card>
    </Col>
  );
};

export default AdminActivities;
